export default "__VITE_ASSET__CT0Y3FOf__"